import * as ACTIONS from './actions';

/**
 * Default global app state
 */
export const initialState = {
	selectedFilters: {},
	selectedTab: '',
};

/**
 * Reducer function passed to 'useReducer' hook for updating global app state
 * @param {object} state Global app state
 * @param {object} action Action to be performed
 * @returns {object} Updated global app state
 */
export const appReducer = (state = initialState, action) => {
	switch (action.type) {
		case ACTIONS.SET_SELECTED_TAB:
			return { ...state, selectedTab: action.payload };

		case ACTIONS.SET_SELECTED_FILTERS:
			return { ...state, selectedFilters: { ...action.payload } };

		default:
			return state;
	}
};
